module.exports = __webpack_public_path__ + "img/img4.adcece06.png";